import { Form, Formik } from "formik";
import { useContext } from "react";
import { Link } from "react-router-dom";
import Logo from "../../../assets/images/logo.png";
import FormInput from "../../../components/FormInput";
import { AuthContext } from "../../../contexts/AuthContext";
import { validationSchema } from "./login-page.validation";

export default function LoginPage() {
  const { handleLogin } = useContext(AuthContext);

  return (
    <section
      style={{
        backgroundColor: "white",
        backgroundImage:
          "url('https://d3fgk2078as9ko.cloudfront.net/assets/login.jpg')",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
      className="ec-page-content section-space-p"
    >
      <div className="container">
        <div className="row">
          <div className="ec-login-wrapper">
            <div className="ec-login-container">
              <div className="account_form">
                <div className="text-center">
                  <img width="100px" src={Logo} />
                </div>
                <div className="text-center">
                  <h3>Welcome to</h3>
                  <h3
                    style={{
                      fontWeight: "bold",
                    }}
                  >
                    Prince Art Exporter
                  </h3>
                  <h5>One Of A Kind Store</h5>
                </div>
              </div>
              <div className="ec-login-form">
                <Formik
                  initialValues={{
                    username: "",
                    password: "",
                  }}
                  validationSchema={validationSchema}
                  onSubmit={handleLogin}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    /* and other goodies */
                  }) => (
                    <Form>
                      <FormInput
                        name="username"
                        label={"Username"}
                        isRequired
                        type={"text"}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className=""
                        placeholder={"Username"}
                        error={errors.username}
                        touched={touched.username}
                        value={values.username}
                      />
                      <FormInput
                        name="password"
                        label={"Password"}
                        isRequired
                        type={"password"}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder={"Password"}
                        error={errors.password}
                        className=""
                        touched={touched.password}
                        value={values.password}
                      />
                      <span className="ec-login-wrap ec-login-btn">
                        <button className="btn btn-primary" type="submit">
                          Login
                        </button>
                        <span className="text-center mt-3">
                          Don't have an account?{" "}
                          <Link to="/register">Create Account</Link>
                        </span>
                      </span>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
